import { render, staticRenderFns } from "./PurchaseModal.vue?vue&type=template&id=8f461d7c&scoped=true&"
import script from "./PurchaseModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseModal.vue?vue&type=style&index=0&id=8f461d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f461d7c",
  null
  
)

export default component.exports